/**
 * Created by jonas on 2022-06-15.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {CollectableView} from "./subviews/CollectableView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap, TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";

export class SushiCollectView extends PIXI.Container implements StageLayer {
    private collectables: CollectableView[];
    private logo: TimelineSprite;
    private view: PIXI.Container;
    private collectableSymbols: string[] = ["M1", "M4", "L2"];
    private _sushiLogo: TimelineSprite;

    constructor() {
        super();
        this.name = "SushiCollectView";
        this.init();
    }

    onResize(): void {

        if (NolimitApplication.isLandscape) {
            this.view.scale.set(1, 1);
            this.view.position.set(-130, 85);
            this.logo.position.set(0, 0);

            this.collectables[0].position.set(0, 125);
            this.collectables[1].position.set(0, 280);
            this.collectables[2].position.set(0, 435);

            this.view.addChild(this.collectables[0]);
            this.view.addChild(this.collectables[1]);
            this.view.addChild(this.collectables[2]);

        } else {
            this.view.scale.set(0.8, 0.8);
            this.view.position.set(200, 45);
            this.logo.position.set(0, 0);

            this.collectables[0].position.set(0, -90);
            this.collectables[1].position.set(-110, -70);
            this.collectables[2].position.set(110, -70);

            this.view.addChild(this.collectables[1]);
            this.view.addChild(this.collectables[2]);
            this.view.addChild(this.collectables[0]);
        }

        this.view.addChild(this.logo);

    }

    public updateCollected(collected: string[]): gsap.core.Timeline {
        const tl = gsap.timeline();
        for (let i: number = 0; i < collected.length; i++) {
            const collectIndex = this.getIndexForCollectedSymbol(collected[i]);
            if (!this.collectables[collectIndex].isCollected) {
                tl.add(this.collectables[collectIndex].collect());
            }
        }
        if (collected.length === 3) {
            tl.add(this.playSushiLogoAnim());
        }
        return tl;
    }

    public resetAll(): gsap.core.Timeline {
        const tl = gsap.timeline();
        for (let i: number = 0; i < this.collectables.length; i++) {
            if (this.collectables[i].isCollected) {
                tl.add(this.collectables[i].reset());
            }
        }
        return tl;
    }


    public show() {
        this.view.visible = true;
    }

    public hide() {
        this.view.visible = false;
    }

    private init() {
        this.view = new PIXI.Container();
        this.addChild(this.view);
        this.collectables = [
            new CollectableView("salmon"), //M1
            new CollectableView("rice"), //M4
            new CollectableView("soy") //L2
        ];

        this.logo = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.SUSHI_LOGO));
        this.logo.setFrame(0);
        this.logo.anchor.set(0.5, 0.5);

        this.onResize();

    }

    private getIndexForCollectedSymbol(symbolName: string) {
        return this.collectableSymbols.indexOf(symbolName);

    }

    private playSushiLogoAnim(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let sushiLogo: TimelineSprite = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures("sushiLogo"));
        sushiLogo.anchor.set(0.5, 0.5);
        sushiLogo.position.set(0);
        sushiLogo.hide();

        let glimmer: TimelineSprite = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures("glimmer"));
        glimmer.anchor.set(0.5, 0.5);
        glimmer.position.set(20, 220);
        glimmer.hide();

        this.view.addChild(sushiLogo, glimmer);
        tl.add(() => {KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.COUNT_MEDIUM)});
        tl.add(sushiLogo.getAnimationAutoShowHide(true, true));
        tl.add(glimmer.getAnimationAutoShowHide(true, true));
        tl.add(() => {
            sushiLogo.removeChild();
            glimmer.removeChild();
        });
        return tl;
    }

}